import { render, staticRenderFns } from "./TranscriptionBlockRow.vue?vue&type=template&id=3931c279&scoped=true"
import script from "./TranscriptionBlockRow.vue?vue&type=script&lang=js"
export * from "./TranscriptionBlockRow.vue?vue&type=script&lang=js"
import style0 from "./TranscriptionBlockRow.vue?vue&type=style&index=0&id=3931c279&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3931c279",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3931c279')) {
      api.createRecord('3931c279', component.options)
    } else {
      api.reload('3931c279', component.options)
    }
    module.hot.accept("./TranscriptionBlockRow.vue?vue&type=template&id=3931c279&scoped=true", function () {
      api.rerender('3931c279', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rows/TranscriptionBlockRow.vue"
export default component.exports